import { t } from "ttag";

import { type RouteTab, RouteTabs } from "metabase/common/components/RouteTabs";
import { useSetting } from "metabase/common/hooks";
import {
  PLUGIN_ADMIN_PERMISSIONS_TABS,
  PLUGIN_APPLICATION_PERMISSIONS,
} from "metabase/plugins";
import { Box } from "metabase/ui";

import type { PermissionsPageTab } from "./PermissionsPageLayout";

interface PermissionsTabsProps {
  tab: PermissionsPageTab;
  onChangeTab: (tab: PermissionsPageTab) => void;
}

export const PermissionsTabs = ({ tab, onChangeTab }: PermissionsTabsProps) => {
  const isUsingTenants = useSetting("use-tenants");

  const adminPermissionsTabs = isUsingTenants
    ? PLUGIN_ADMIN_PERMISSIONS_TABS.tabs
    : PLUGIN_ADMIN_PERMISSIONS_TABS.tabs.filter(
        (tab) =>
          tab.value !== "tenant-collections" &&
          tab.value !== "tenant-specific-collections",
      );

  const tabs: RouteTab<PermissionsPageTab>[] = [
    { name: t`Data`, value: "data" },
    { name: t`Collections`, value: "collections" },
    ...adminPermissionsTabs,
    ...PLUGIN_APPLICATION_PERMISSIONS.tabs,
  ].map(({ name, value }) => ({
    label: name,
    value,
    to: `/admin/permissions/${value}`,
  }));

  return (
    <Box mt="sm" pl="xl">
      <RouteTabs
        aria-label={t`Permission sections`}
        tabs={tabs}
        value={tab}
        onChange={onChangeTab}
      />
    </Box>
  );
};
